mutation lockPosition($where: JSON) {
    lockPosition(where: $where) 
}